import { type ApiProblem, putUpload, toProblem, type UploadLink } from '@rental/contracts/client'
import { API_ORIGIN, APP_VERSION, apiFetch, keeper } from '../api'

/**
 * Sends a photo to its link (W2). The link is on this app's own API and needs
 * the session: the web app's cookies, or the iPad app's header (A1, through
 * the keeper). The server takes it only from the device that asked. An
 * aborted send (S4: no answer in time) is a dropped connection.
 */
export async function sendPhoto(
  link: UploadLink,
  photo: Blob,
  signal?: AbortSignal,
): Promise<ApiProblem | null> {
  let response: Response
  try {
    response = await putUpload(link, photo, {
      baseUrl: API_ORIGIN,
      appVersion: APP_VERSION,
      credentials: keeper ? 'omit' : 'same-origin',
      fetch: apiFetch,
      ...(signal ? { signal } : {}),
    })
  } catch {
    return { kind: 'network' }
  }
  if (response.ok) return null
  return toProblem(response.status, await response.json().catch(() => undefined))
}
